module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-04.c8263b5f.jpg";